import constant from './const'
export default {
  constant,
}
